/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.FameAdvantage {

    export class ApplyStudentTemplateController {
        static $inject = [
            '$mdDialog',
            'meevo.components.short-cuts.ShortCutsService',
        ];

        public mainTab: boolean;
        public compensationsTab: boolean;
        public deductionTab: boolean;
        public categories = {enabled: false, updateType: Model.AppliedTemplateSectionUpdateTypeEnum.Replace};
        public servicesTab = {enabled: false, updateType: Model.AppliedTemplateSectionUpdateTypeEnum.Replace};
        public locationsTab = {enabled: false, updateType: Model.AppliedTemplateSectionUpdateTypeEnum.Merge};
        public commissionsOverrideTab = {
            enabled: false,
            updateType: Model.AppliedTemplateSectionUpdateTypeEnum.Replace
        };
        public all: boolean;
        public selectedTemplate: any;

        private shortCutGroup: IShortCutGroup;

        get toggleAll(): boolean {
            return this.all;
        }

        set toggleAll(value: boolean) {
            this.mainTab = this.compensationsTab = this.deductionTab = this.commissionsOverrideTab.enabled = this.servicesTab.enabled = this.locationsTab.enabled = this.all = value;
        }

        constructor(private $mdDialog: ng.material.IDialogService,
                    private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService) {
            this.configureShortCuts();
            this.shortCutsService.activateGroup(this.shortCutGroup);
            this.toggleAll = true;
        }


        public cancel(): void {
            this.$mdDialog.cancel();
            this.shortCutsService.deactivateGroup(this.shortCutGroup);
        }

        public applyTemplates(): void {
            if (!this.selectedTemplate) {
                return;
            }

            let appliedTemplate: IAppliedTemplate = {
                templateId: this.selectedTemplate.id,
                displayName: this.selectedTemplate.displayName,
                sections: []
            };
            // collect apply sections
            if (this.all || this.mainTab) {
                appliedTemplate.sections.push({
                    sectionType: Model.AppliedTemplateSectionTypeEnum.Main,
                    updateType: Model.AppliedTemplateSectionUpdateTypeEnum.Replace
                });
            }
            if (this.all || this.compensationsTab) {
                appliedTemplate.sections.push({
                    sectionType: Model.AppliedTemplateSectionTypeEnum.Compensations,
                    updateType: Model.AppliedTemplateSectionUpdateTypeEnum.Replace
                });
            }
            if (this.all || this.deductionTab) {
                appliedTemplate.sections.push({
                    sectionType: Model.AppliedTemplateSectionTypeEnum.Deduction,
                    updateType: Model.AppliedTemplateSectionUpdateTypeEnum.Replace
                });
            }
            if (this.all || this.commissionsOverrideTab.enabled) {
                appliedTemplate.sections.push({
                    sectionType: Model.AppliedTemplateSectionTypeEnum.CommissionsOverrides,
                    updateType: this.commissionsOverrideTab.updateType
                });
            }
            if (this.all || this.categories.enabled) {
                appliedTemplate.sections.push({
                    sectionType: Model.AppliedTemplateSectionTypeEnum.Categories,
                    updateType: this.categories.updateType
                });
            }
            if (this.all || this.servicesTab.enabled) {
                appliedTemplate.sections.push({
                    sectionType: Model.AppliedTemplateSectionTypeEnum.Services,
                    updateType: this.servicesTab.updateType
                });
            }
            if (this.all || this.locationsTab.enabled) {
                appliedTemplate.sections.push({
                    sectionType: Model.AppliedTemplateSectionTypeEnum.Locations,
                    updateType: this.locationsTab.updateType
                });
            }

            this.$mdDialog.hide(appliedTemplate);
            this.shortCutsService.deactivateGroup(this.shortCutGroup);
        }

        private configureShortCuts() {
            this.shortCutGroup = new ShortCutGroup([
                {
                    shortCutName: 'MODAL_APPLY_BUTTON',
                    callback: () => {
                        this.applyTemplates();
                    }
                },
                {
                    shortCutName: 'MODAL_CANCEL_BUTTON',
                    callback: (event: Event, hotkey: ng.hotkeys.Hotkey) => {
                        event.preventDefault();

                        this.cancel();
                    }
                }
            ], {
                groupLevel: Components.ShortCuts.GroupLevels.Modal,
                deactivateGlobal: true,
            });
        }
    }

    angular.module('meevo.plugins.fameAdvantage')
        .controller('meevo.plugins.fameAdvantage.ApplyStudentTemplateController', ApplyStudentTemplateController);
}
